import {IconButton, Tooltip} from "@mui/material";
import {BorderColor} from "@mui/icons-material";
import React from "react";
import {useTranslation} from "react-i18next";
import {ICellRendererParams} from "ag-grid-community";

const UpdateActionIcon = ({
                              styles,
                              action,
                              params
                          }: { styles: any, action: Function, params: ICellRendererParams }) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <Tooltip arrow title={t("pricing:tooltips.update")} placement={"right-start"}>
            <IconButton
                aria-label="update"
                onClick={() => action(params.data)}
                sx={styles}
            >
                <BorderColor/>
            </IconButton>
        </Tooltip>
    );
};

export default UpdateActionIcon;